import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import React, { Suspense, useEffect } from 'react';

import {
  DashboardPage,
  Login,
  Register,


} from './Pages/index';
import TestScheduleMeeting from './Pages/TestScheduleMSg';
import CartificatePage from './Pages/CartificatePage';
import AssessmentsPage from './Pages/AssessmentsPage';
import ClassSummeryPage from './Pages/ClassSummeryPage';
import EnrichmentClassesPage from './Pages/EnrichmentClassesPage';
import RewardPage from './Pages/RewardPage';
import SalesProfileForm from './Pages/SalesProfileForm';
import ProtectedRoute from './ProtectedRoute'; // Import the ProtectedRoute component

import StudentHistory from './Components/ClassHistory';
import { useRedirectIfAuthenticated } from './useAuth'; // Import redirect hook
import CreateNotes from './Components/CreateNotes';
import ViewNotes from './Components/ViewNotes';
import DailyPerformance from './Components/DailyPerformance';
import ProfilePage from './Components/ProfilePage';
import TeacherProfile from './Components/TeacherProfile';
import ShowCurriculum from './Components/ShowCurriculam';
import curriculumData from './json/Curiculam'; // Assuming curriculumData is in a separate file
import TestDashboard from './Components/TestDashboard';
import NotFound404 from './Pages/NotFound';
import ChatComponent from './Components/TestChat';
import StudentHomeworkList from './Components/Homework';
import PublicSpeakingDesign from './Pages/TestClasSummery';
import MaintenancePopup from './Components/MaintenancePopup';
import StudentQuizDashboard from './Components/StudentQuizView';
import VideoCourse from './Pages/VideoCourse';
import StudentDashboard from './newtest/studentdashboard/StudentDashboard';
import Activities from './newtest/activities/ActivityCard';
import HelpSection from './newtest/help/Help';
import MyRewardsSection from './newtest/reward/Reward';
import ProfileSection from './newtest/profile/Profile';
import Layout from './Layout'; // Adjust import path as needed
import InvitationPage from './Pages/InvitationPage';
import WritingSpace from './newtest/activities/WritingSpace';
import TestLayout from './newtest/Layout/Layout.js'; // Corrected import path and added .jsx extension
import AchievementsPage from './newtest/achivement/AchivementPage.js';
import DailyPerformanceDashboard from './newtest/DailyPerformance/DailyPerformance.js';
import MyInstructors from './newtest/studentdashboard/MyInustructors.js';
import InstructorProfile from './newtest/teacher/InstructorProfile.js';
import MyCourse from './newtest/course/MyCourse.js';
import Attendance from './newtest/attendace/Attendance.js';
import GamePage from './newtest/game/GameZone.js';
import QuizApp from './newtest/quiz/Quiz.js';
import WordWizard from './newtest/game/WordWizard.js';
import MemoryMatch from './newtest/game/MemoryMatch.js';
import TicTacToe from './newtest/game/TicTacToe.js';
import MoleGame from './newtest/game/MoleGame.js';
import SimonGame from './newtest/game/SimonGame.js';
import Snackgame from './newtest/game/Snackgame.js';
import RacingLimitsGame from './newtest/game/RacingLimitsGame.js';

import Ebook from './newtest/ebook/Ebooks.js';
import Cartificatenew from './newtest/Certificatenew.js';
import Homework from './newtest/homework/Homework.js';
import MathMonsters from './newtest/game/MathMonsters.js';
import Ludo from './newtest/game/Ludo.js';
import FlashcardsPage from './newtest/Flashcards/FlashcardsPage.js';
import StudyTimerPage from './newtest/StudyTimer/StudyTimerPage.js';

const App = () => {
  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const tokenTimestamp = localStorage.getItem('tokenTimestamp');

    if (!token || !tokenTimestamp) {
      logout();
      return;
    }

    const currentTime = Date.now();
    const tokenAge = currentTime - parseInt(tokenTimestamp, 10);
    const fiveDaysInMilliseconds = 5 * 24 * 60 * 60 * 1000;

    if (tokenAge > fiveDaysInMilliseconds) {
      logout();
    }
  }, [logout]);

  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>

        <Routes>
          <Route path="/login" element={<LoginWithRedirect />} />
          <Route path='/404' element={<NotFound404 />} />
          <Route path='*' element={<Navigate replace to='/404' />} />
          <Route path="/join-event" element={<InvitationPage />} />
          <Route element={<ProtectedRoute />}>

            <Route path="test" element={<Layout />}>
              <Route index element={<DashboardPage />} />
              <Route path="reward" element={<RewardPage />} />
                            <Route path="reward" element={<RewardPage />} />


              <Route path="activityclass" element={<EnrichmentClassesPage />} />
              <Route path="classsummary" element={<ClassSummeryPage />} />
              <Route path="assessments" element={<AssessmentsPage />} />
              <Route path="achievements" element={<CartificatePage />} />
              <Route path="assessmentss" element={<TestScheduleMeeting />} />
              <Route path="sale" element={<SalesProfileForm />} />
              <Route path="createNotes" element={<CreateNotes />} />
              <Route path="viewnotes" element={<ViewNotes />} />
              <Route path="performance" element={<DailyPerformance />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="quiz" element={<StudentQuizDashboard />} />

              <Route path="teacher/profile/:teacherId" element={<TeacherProfile />} />

              {/* <Route path="Curriculum" element={<ShowCurriculum curriculumData={curriculumData} />} /> */}

              <Route path="chat" element={<ChatComponent />} />
              <Route path="homework" element={<StudentHomeworkList />} />

              <Route path="Curriculum" element={<PublicSpeakingDesign />} />


              {/* <Route path="Curriculum" element={<VideoCourse />} /> */}
              <Route path="history" element={<StudentHistory />} />


              {/* //test */}
              {/* <Route path="/testdash" element={<StudentDashboard />} />
              <Route path="/act" element={<Activities />} />
              <Route path="/help" element={<HelpSection />} />

              <Route path="/testreward" element={<MyRewardsSection />} />

              <Route path="/testpro" element={<ProfileSection />} />
<Route path="/write" element={<WritingSpace />} /> */}
            </Route>

            {/* Test routes using TestLayout */}
            <Route path="/" element={<TestLayout />}> {/* A base path for test routes, or you can directly nest */}
              <Route path="/" element={<StudentDashboard />} /> {/* /test/dash */}
              <Route path="/activityclass" element={<Activities />} /> {/* /test/act */}
              <Route path="/help" element={<HelpSection />} /> {/* /test/help */}
              <Route path="/reward" element={<RewardPage />} /> {/* /test/reward */}
              <Route path="/profile" element={<ProfileSection />} /> {/* /test/pro */}
              <Route path="/write" element={<WritingSpace />} /> {/* /test/write */}
              <Route path="/DailyPerformance" element={<DailyPerformanceDashboard />} /> {/* /test/chat */}
              <Route path="/achivement" element={<AchievementsPage />} /> {/* /test/write */}
              <Route path="/teacher/profile/:teacherId" element={<InstructorProfile />} /> {/* /test/write */}
              <Route path="/course" element={<MyCourse />} /> {/* /test/write */}
              <Route path="/attendance" element={<Attendance />} /> {/* /test/write */}
              <Route path="/quiz" element={<QuizApp />} />
              <Route path="/game" element={<GamePage />} /> {/* /test/chat */}
              <Route path="/word-wizard" element={<WordWizard />} /> {/* /test/chat */}
              <Route path="/memory-match" element={<MemoryMatch />} /> {/* /test/chat */}
              <Route path="/video" element={<VideoCourse />} />
              <Route path="/Ebook" element={<Ebook />} />
              <Route path="/createNotes" element={<CreateNotes />} />
              {/* <Route path="/Homework" element={<Homework />} /> */}
              <Route path="/homework" element={<StudentHomeworkList />} />


              <Route path="/word-wizard" element={<WordWizard />} /> {/* /test/word-wizard */}
              <Route path="/memory-match" element={<MemoryMatch />} /> {/* /test/memory-match */}
              <Route path="/TicTacToe" element={<TicTacToe />} />
              <Route path="/molegame" element={<MoleGame />} />
              <Route path="/simongame" element={<SimonGame />} />
                            <Route path="/race" element={<RacingLimitsGame />} />

              <Route path="/snackgame" element={<Snackgame />} />
              <Route path="/math-monsters" element={<MathMonsters />} />
              {/* <Route path="/activityclass" element={<EnrichmentClassesPage />} /> */}
              <Route path="/viewnotes" element={<ViewNotes />} />

              <Route path="/cartificate" element={<Cartificatenew />} />
              <Route path="/racing" element={<Ludo />} />
                            <Route path="/Studytimer" element={<StudyTimerPage />} />

              
              <Route path="/flash" element={<FlashcardsPage />} />

            </Route>
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

// Component to handle redirection if authenticated
const LoginWithRedirect = () => {
  useRedirectIfAuthenticated(); // Redirect if authenticated
  return <Login />;
};

export default App;
